
import { RiskbedomningData, Fraga } from "@/types/riskbedomning";
import { fragorData } from "@/lib/fragorData";

/**
 * Build a comprehensive question list for export:
 * - Start with provided relevant questions (often fragorData + AFS additions)
 * - Ensure all static questions from fragorData are included
 * - Add placeholders for any question IDs that exist only in svar (dynamic/custom)
 */
export const getAllQuestionsForExport = (
  data: RiskbedomningData,
  relevantaFragor: Fraga[],
  selectedQuestionIds?: Set<string>
): Fraga[] => {
  const byId = new Map<string, Fraga>();

  // 1) Include provided relevant questions first
  for (const f of relevantaFragor || []) {
    byId.set(f.id, f);
  }

  // 2) Ensure all static questions are present
  for (const f of fragorData || []) {
    if (!byId.has(f.id)) byId.set(f.id, f);
  }

  // 3) Add placeholders for any answered IDs not present in the lists
  const svar = data?.svar || {};
  for (const id of Object.keys(svar)) {
    if (!byId.has(id)) {
      const qText = svar[id]?.questionText || `Fråga ${id}`;
      byId.set(id, {
        id,
        text: qText,
        kategori: "Övrigt",
      });
    }
  }

  const allQuestions = Array.from(byId.values());
  
  // 4) Filter by selected questions if provided
  if (selectedQuestionIds && selectedQuestionIds.size > 0) {
    return allQuestions.filter(q => selectedQuestionIds.has(q.id));
  }

  return allQuestions;
};
